<template>
  <header>
    <div ref="header" :class="{'open-mobile-menu': showMobMenu}">
      <div class="header-wrapper">
        <div class="logo">
          <router-link to="/">
            <img src="/static/img/logo.png" alt="logo">
          </router-link>
        </div>
        <button type="button" class="trigger-menu-btn" @click="showMobMenu = !showMobMenu">
          <img v-if="!showMobMenu" src="/static/img/hamburger-menu.png" alt="menu">
          <img v-else src="/static/img/close.png" alt="close">
        </button>
        <div class="main-menu">
          <nav>
            <ul>
              <!-- <li>
                <router-link to="/">Features</router-link>
              </li>
              <li>
                <router-link to="/">Industry Examples</router-link>
              </li> 
              <li>
                <a @click="openModal">Contact</a>
              </li>-->
            </ul>
          </nav>
          <start-now></start-now>
        </div>
      </div>
    </div>
    <div v-show="showMobMenu" class="mobile-menu">
      <nav>
        <ul>
          <!-- <li>
            <router-link to="/">Features</router-link>
          </li>
          <li>
            <router-link to="/">Industry Examples</router-link>
          </li> 
          <li>
            <a @click="openModal">Contact</a>
          </li>-->
        </ul>
      </nav>
      <start-now></start-now>
    </div>
    <transition name="slide-fade">
      <popup v-if="showPopup" @close="showPopup = false"></popup>
    </transition>
  </header>
</template>

<script>
  import StartNow from './StartNow.vue'
  import Popup from './Popup.vue'

  export default {
    name: 'Header',
    components: {
      'start-now': StartNow,
      'popup': Popup
    },
    data () {
      return {
        showMobMenu: false,
        showPopup: false
      }
    },
    methods: {
      handleScroll: function () {
        if ((document.body.getBoundingClientRect()).top < 0 && !this.showMobMenu) {
          this.$refs.header.classList.add('fixed-header')
        } else {
          this.$refs.header.classList.remove('fixed-header')
        }
      },
      openModal () {
        this.showPopup = true
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style scoped>
  header {
    position: fixed;
    width: 100%;
    z-index: 10;
    transition: all 1s;
  }
  .header-wrapper {
    width: 90%;
    margin: 0 auto;
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .main-menu {
    display: flex;
    align-items: center;
  }
  .header-wrapper li {
    display: inline-block;
    margin: 0 30px;
  }
  header a {
    font-family: 'RubicMedium', sans-serif;
    color: #2190f7;
    font-size: 16px;
    line-height: 19px;
    text-decoration: none;
  }
  header >>> .btn-start {
    padding: 12px 31px;
    margin-left: 30px;
  }
  .trigger-menu-btn {
    display: none;
  }
  .mobile-menu {
    display: none;
    position: absolute;
    top: 70px;
    left: -5%;
    right: -5%;
    padding-bottom: 60px;
    text-align: center;
    background: url('/static/img/mobile_bg.svg') 0 100% no-repeat;
    background-size: cover;
  }
  .fixed-header {
    background-color: #160e24;
  }
  @media (max-width: 1199px) {
    .header-wrapper {
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  @media (max-width: 991px) {
    .header-wrapper li {
      margin: 0 15px;
    }
    header >>> .btn-start {
      margin-left: 15px;
    }
  }
  @media (max-width: 767px) {
    .header-wrapper li {
      margin: 0 5px;
    }
    header >>> .btn-start {
      margin-left: 10px;
    }
  }
  @media (max-width: 670px) {
    .main-menu {
      display: none;
    }
    .mobile-menu {
      display: block;
    }
    .header-wrapper {
      padding-bottom: 10px;
    }
    .trigger-menu-btn {
      display: block;
      background-color: transparent;
      border: none;
    }
    .mobile-menu li {
      margin-top: 20px;
    }
    header >>> .btn-start {
      padding-left: 40px;
      padding-right: 40px;
      margin: 20px 0 40px;
    }
    .open-mobile-menu {
      background-color: #fff;
    }
  }
  @media (max-width: 460px) {
    header a {
      font-size: 15px;
      line-height: 18px;
    }
    header >>> .btn-start {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue